export default __webpack_public_path__ + "static/media/check-logo.8a8fbe27.svg";